import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

const DailyStatusView = ({value}) => {
  const {t} = useTranslation('registers');

  if (typeof value?.dailyDisabled !== 'undefined') {
    return (
      <div>
        {value?.dailyDisabled ? t('dailyClosed') : t('dailyOpened') }
      </div>
    );
  } else {
    return (
      <div>
        {value? t('dailyClosed') : t('dailyOpened') }
      </div>
    );
  }
};

DailyStatusView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Date component in a table cell
 * @param {string} value this is value of de column
 * */
export const renderDailyStatusView = (value) => {

  return (
    <DailyStatusView value={value}/>
  );
};
